class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.nextPage = this.dataset.nextPage;
    this.loading = false;

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    });

    this.observer.observe(this);
  }

  handleIntersect(entries) {
    const entry = entries[0];
    if (entry.isIntersecting && !this.loading) {
      this.loadMoreProducts();
    }
  }

  loadMoreProducts() {
    if (this.loading) return;

    this.loading = true;
    this.classList.add("loading");
    this.innerHTML = "LOADING...";

    fetch(this.nextPage)
      .then((response) => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, "text/html");
        const newProducts = doc.getElementById("product-grid").innerHTML;

        document
          .getElementById("product-grid")
          .insertAdjacentHTML("beforeend", newProducts);

        const nextLoadMore = doc.querySelector(".load-more");

        if (nextLoadMore) {
          this.nextPage = nextLoadMore.dataset.nextPage;
        } else {
          this.observer.disconnect();
          this.remove();
        }
      })
      .finally(() => {
        this.loading = false;
        this.innerHTML = "LOAD MORE";
        this.classList.remove("loading");
      });
  }
}

customElements.define("load-more", LoadMore);